(() => {
  if (customElements.get("brand-philosophy")) return;

  class BrandPhilosophy extends HTMLElement {
    connectedCallback() {
      if (this.dataset.brandPhilosophyAnimateInit === "true") return;
      this.dataset.brandPhilosophyAnimateInit = "true";

      this.items = Array.from(
        this.querySelectorAll("[data-brand-philosophy-photo-enter]"),
      );
      if (!this.items.length) return;

      if (!("IntersectionObserver" in window)) {
        this.items.forEach((item) => item.classList.add("is-visible"));
        return;
      }

      this.observer = new IntersectionObserver(
        (entries, instance) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add("is-visible");
            instance.unobserve(entry.target);
          });
        },
        {
          root: null,
          rootMargin: "0px 0px -12% 0px",
          threshold: 0.2,
        },
      );

      this.items.forEach((item) => this.observer.observe(item));
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      this.items = null;
      if (this.dataset.brandPhilosophyAnimateInit) {
        delete this.dataset.brandPhilosophyAnimateInit;
      }
    }
  }

  customElements.define("brand-philosophy", BrandPhilosophy);
})();
